import React from "react";

import isIntuit from "Intuit/isIntuit";

import * as Cobalt from "Cobalt/Card";
import * as Common from "Common/Card";

import { useThemeContext } from "./Context";

import type { StyleProps } from "Utils/styleProps";

export interface CardProps extends StyleProps {
  theme?: "flat" | "elevated" | "hoverable" | "disabled";
  /**
  @ignore
  * */
  className?: string;
  /**
  @ignore
  * */
  children?: React.ReactNode;
}

export interface CardSubcomponentProps {
  className?: string;
  children?: React.ReactNode;
}

export const Card = (props: CardProps) => {
  const { cobalt, intuit } = useThemeContext();
  const showCobalt = cobalt && !(intuit && isIntuit());
  const CardComponent = showCobalt ? Cobalt.Card : Common.Card;
  return <CardComponent {...props} />;
};
export const CardHeader = (props: CardSubcomponentProps) => {
  const { cobalt, intuit } = useThemeContext();
  const showCobalt = cobalt && !(intuit && isIntuit());
  const CardComponent = showCobalt ? Cobalt.CardHeader : Common.CardHeader;
  return <CardComponent {...props} />;
};

export const CardSection = (props: CardSubcomponentProps) => {
  const { cobalt, intuit } = useThemeContext();
  const showCobalt = cobalt && !(intuit && isIntuit());
  const CardComponent = showCobalt ? Cobalt.CardSection : Common.CardSection;
  return <CardComponent {...props} />;
};
export const CardSeparator = (props: CardSubcomponentProps) => {
  const { cobalt, intuit } = useThemeContext();
  const showCobalt = cobalt && !(intuit && isIntuit());
  const CardComponent = showCobalt ? Cobalt.CardSeparator : Common.CardSeparator;
  return <CardComponent {...props} />;
};
export const CardFooter = (props: CardSubcomponentProps) => {
  const { cobalt, intuit } = useThemeContext();
  const showCobalt = cobalt && !(intuit && isIntuit());
  const CardComponent = showCobalt ? Cobalt.CardFooter : Common.CardFooter;
  return <CardComponent {...props} />;
};
